import { configDevUrl, walletApi } from "../api";

const CommisionModule = () => {
    return {
        DownlineProduct: function (data) {
            return configDevUrl.get(`${data?.url}?walletId=${data.walletId}`);
        },
        MoveCommision: function (data) {
            return walletApi.post(`Wallet/transfercommision`, data);
        },
    };
};

export const CommisionService = {
    commisionModule: CommisionModule,
};
// https://config-dev.flexmonie.com/v2/api/DownlineProduct/DownlineProducts?walletId=33
// https://config-dev.flexmonie.com/v1/api/AggregatorProduct/AggregatorProducts?walletId=1
